import { select } from 'redux-saga/effects'
import requestRepairDocumentSource from './requestRepairDocumentSource'
import sweetalert from 'sweetalert2'

export default function * requestRepairAllDocumentSources (action) {
  const { onEnd } = action.payload

  const state = yield select()

  const array = state.kanbo.documentSources.documentSources
  const length = array.length

  if (length) {
    try {
      sweetalert({
        type: 'info',
        text: state.kanbo.locale.messages['DOCUMENTS_SOURCES_REPAIR_IN_PROGRESS'],
        showConfirmButton: false,
        allowOutsideClick: false
      })
    } catch (e) {}

    for (let i = 0; i < length; i++) {
      const documentSource = state.kanbo.documentSources.documentSourcesById[array[i]]
      if (documentSource && !documentSource.isBusy) {
        yield requestRepairDocumentSource({
          payload: {
            id: documentSource.id
          }
        })
      }
    }

    sweetalert.close()
  }

  if (onEnd) onEnd()
}
